/** The superadmin's Platform screen: business type and business modules. */
export default {
  'platform.title': 'Platform',
  'platform.subtitle': 'What kind of business this is and which modules it runs. Only the superadmin sees this screen.',
  'platform.typeHeading': 'Business type',
  'platform.type.SUPERMARKET': 'Supermarket',
  'platform.type.HARDWARE': 'Hardware shop',
  'platform.type.BISTRO': 'Bistro / café',
  'platform.typeHint.SUPERMARKET': 'Fast barcode billing, loose goods by weight, batches and expiry.',
  'platform.typeHint.HARDWARE': 'Credit customers, quotations, variants, serial numbers, sale by length.',
  'platform.typeHint.BISTRO': 'Tables, kitchen display and printers, add-ons, tips and service charge.',
  'platform.applyDefaults': "Reset modules to this type's defaults",
  'platform.modulesHeading': 'Modules',
  'platform.modulesHint': 'A module that is off disappears from the menu and the server refuses its screens.',
  'platform.plannedHeading': 'Coming next',
  'platform.plannedHint': 'On the roadmap. They switch on here once they are built.',
  'platform.planned': 'Planned',
  'platform.recommended': 'Default for {type}',
  'platform.unsaved': 'Unsaved changes',
  'platform.saved': 'Saved. The business now runs as: {type}.',
  'platform.reset': 'Discard changes',
  'platform.planHeading': 'Plan',
  'platform.planHint': 'What this store pays for. A module above the plan stays off even if switched on.',
  'platform.plan.BASIC': 'Basic',
  'platform.plan.PRO': 'Pro',
  'platform.plan.ADVANCED': 'Advanced',
  'platform.needsPlan': 'Needs {plan}',
  // API error codes (errorMessage): English shows the server's own words; these feed other languages.
  'error.MODULE_DISABLED': 'This module is switched off for this business.',
  'error.MODULE_NOT_AVAILABLE': 'This module is not built yet, so it cannot be switched on.',
  'platform.module.purchasing': 'Purchasing',
  'platform.module.credit': 'Store credit',
  'platform.module.csvImport': 'CSV import',
  'platform.module.marginAlerts': 'Cost and margin alerts',
  'platform.module.quotations': 'Quotations and estimates',
  'platform.module.variants': 'Product variants',
  'platform.module.serials': 'Serial numbers and warranty',
  'platform.module.altUnits': 'Buy and sell in different units',
  'platform.module.orders': 'Open orders and split bills',
  'platform.module.tables': 'Tables and floor plan',
  'platform.module.kitchen': 'Kitchen display and printers',
  'platform.module.modifiers': 'Add-ons and modifiers',
  'platform.module.recipes': 'Recipes',
  'platform.module.serviceCharge': 'Service charge',
  'platform.module.tips': 'Tips',
  'platform.module.takeaway': 'Takeaway and delivery',
  'platform.module.aggregators': 'Swiggy and Zomato orders',
  'platform.module.upiReconciliation': 'UPI soundbox confirm and reconciliation',
  'platform.module.onlineOrdering': 'Online and mobile ordering',
  'platform.module.gatewayPayments': 'Online payment gateway',
  'platform.moduleDesc.purchasing': 'Purchase orders, goods receipts and supplier returns',
  'platform.moduleDesc.credit': 'Sell on account and collect the balance later',
  'platform.moduleDesc.csvImport': 'Bulk-load products and customers from a spreadsheet',
  'platform.moduleDesc.marginAlerts': 'Warns when a supplier raises a cost, with the margin effect and a suggested price',
  'platform.moduleDesc.quotations': 'Quote a price, convert it to an invoice later',
  'platform.moduleDesc.variants': 'Size, colour or finish as one product family',
  'platform.moduleDesc.serials': 'Track each unit sold by its serial',
  'platform.moduleDesc.altUnits': 'Buy by the box or roll, sell by the piece or metre',
  'platform.moduleDesc.orders': 'Orders that stay open until paid, split by item, seat or evenly',
  'platform.moduleDesc.tables': 'Seat guests, move and merge tables',
  'platform.moduleDesc.kitchen': 'Send items to kitchen screens and ticket printers',
  'platform.moduleDesc.modifiers': 'Extra cheese, less sugar, no onion',
  'platform.moduleDesc.recipes': 'Deduct ingredients from stock when a dish is sold',
  'platform.moduleDesc.serviceCharge': 'An optional, taxable charge on the bill',
  'platform.moduleDesc.tips': 'Record tips separately from revenue',
  'platform.moduleDesc.takeaway': 'Parcel orders, delivery address, rider and charges',
  'platform.moduleDesc.aggregators': 'Aggregator orders with their commission tracked',
  'platform.moduleDesc.upiReconciliation': 'Confirm UPI by the soundbox, match payments with the bank statement at day end',
  'platform.moduleDesc.onlineOrdering': 'Customers order from their phone',
  'platform.moduleDesc.gatewayPayments': 'Payment links and online checkout (not planned yet)',
} as const;
